import { Button } from '@components/button';
import { UserPlus } from 'lucide-react';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { AcquirerUser } from '@root/globalTypes';
import { UseMutateFunction } from '@tanstack/react-query';

type EnableUserBtnProps = {
  user: AcquirerUser;
  onEnable: UseMutateFunction<AcquirerUser, Error, string, unknown>;
};

export function EnableAcquirerUserButton({ user, onEnable }: EnableUserBtnProps) {
  const { verifyUserPermission } = useCheckUserPermissions();

  if (!verifyUserPermission(`acquirer_users_enable`) || user.active) {
    return null;
  }

  return (
    <Button
      size="sm"
      className="w-14"
      variant="outline"
      type="button"
      onClick={() => onEnable(user.id)}>
      <UserPlus className="h-5" />
    </Button>
  );
}
